module.exports = __webpack_public_path__ + "static/media/infographics.3ac8c5b1.svg";